import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

/**
 * Post-Incorporation module navigation — spec-48 W1
 * AR-first per BRD §11.3.
 */
export const postIncorporationNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/post-incorporation', label: 'Post-Incorporation Home' },
    ],
  },
  {
    title: 'Matters',
    items: [
      { path: '/post-incorporation/matters', label: 'All Matters' },
      { path: '/tasks', label: 'My Tasks' },
    ],
  },
];
